import React from "react";
import EvaluationForm from "@/components/forms/EvaluationForm";
import { ConcentricMonogram } from "@/components/brand/ConcentricMonogram";
import { Overline } from "@/components/brand/SectionDivider";
import { BRAND } from "@/data/brand";
import { ShieldCheck, Phone } from "lucide-react";
import { AmbientLight } from "@/components/brand/AmbientLight";
import useDocumentTitle from "@/lib/useDocumentTitle";

export default function FreeEvaluation() {
  useDocumentTitle("Free Claim Evaluation | AG Public Adjusting");
  return (
    <main data-testid="evaluation-page" className="relative pt-32 pb-20 min-h-screen bg-midnight-gradient overflow-hidden">
      <AmbientLight size={1200} color="blue" intensity={0.5} style={{ top: "0%", left: "20%" }} />
      <div className="hidden lg:block absolute right-[-100px] top-1/4 opacity-30 pointer-events-none" aria-hidden>
        <ConcentricMonogram size={600} variant="ghost" glowColor="blue" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12 pt-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <Overline className="mb-8">Free Claim Evaluation</Overline>
            <h1 className="font-display-tight text-white text-[clamp(2.8rem,5.5vw,5rem)] leading-[0.95] tracking-[-0.045em]">
              Tell us about
              <br />
              <span className="gold-metallic font-display font-light">the claim.</span>
            </h1>
            <p className="mt-10 text-ag-text-secondary text-lg leading-[1.65] font-light max-w-md">
              A four-step review. No obligation. A senior member of the firm will assess your file and
              recommend the appropriate next step.
            </p>

            <div className="mt-12 space-y-7">
              {[
                ["Contingency-based engagement", "No fee unless the firm recovers on your behalf."],
                ["Confidential review", "Your information is reviewed by the firm only."],
                ["One business day response", "Direct outreach by a senior reviewer."],
              ].map(([t, d]) => (
                <div key={t} className="flex items-start gap-4">
                  <ShieldCheck className="w-5 h-5 text-gold flex-shrink-0 mt-1" strokeWidth={1.3} />
                  <div>
                    <div className="text-white font-display text-lg font-light tracking-[-0.02em]">{t}</div>
                    <div className="text-sm text-ag-text-secondary font-light mt-1">{d}</div>
                  </div>
                </div>
              ))}
            </div>

            <a href={BRAND.phoneHref} data-testid="evaluation-page-call" className="mt-14 btn-ghost-blue inline-flex items-center gap-3">
              <Phone className="w-4 h-4" />
              Or speak directly · {BRAND.phoneDisplay}
            </a>
          </div>

          <div className="lg:col-span-7">
            <EvaluationForm variant="standalone" />
          </div>
        </div>
      </div>
    </main>
  );
}
